import React from 'react';
import classNames from 'classnames/bind';
import SvgIcon from 'components/Icon/Icon';
import { SvgIcons } from 'common/consts/svgIcons';
import styles from './TogglePasswordButton.module.scss';

type Props = {
  isShowed: boolean;
  className?: string;
  onChange: () => void;
};

const TogglePasswordButton = ({
  isShowed = false,
  className,
  onChange,
}: Props) => {
  return (
    <button
      type="button"
      onClick={onChange}
      className={classNames(styles.wrapper, className)}
    >
      {isShowed ? (
        <SvgIcon type={SvgIcons.SHOW_PASSWORD} width={24} />
      ) : (
        <SvgIcon type={SvgIcons.HIDE_PASSWORD} width={24} />
      )}
    </button>
  );
};

export default TogglePasswordButton;
